import React from "react";
import { Trash2Icon, PizzaIcon, FootprintsIcon, DropletsIcon, BoxIcon } from "lucide-react";
import { painPoints } from "../data/landing";
const icons: BoxIcon[] = [Trash2Icon, PizzaIcon, FootprintsIcon, DropletsIcon];
export function PainPoints() {
  return <section className="w-full bg-cream" data-id="element-152" data-mp="26wbox3mjuiny">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-16 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16 lg:py-20" data-id="element-153" data-mp="2bwr13rv3hk4c">
        <div data-id="element-154" data-mp="1xwomcei336tb">
          <h2 className="font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-155" data-mp="1xwyarxnhd5ww">
            El desorden en la cocina sale caro
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-muted" data-id="element-156" data-mp="1nztps15dfgho">
            No es solo cansancio: cada semana sin plan se paga con plata, con salud y con
            tus horas libres.
          </p>
        </div>

        <ul className="divide-y divide-ink/10 border-y border-ink/10" data-id="element-157" data-mp="3iemle069879m">
          {painPoints.map((item, i) => {
          const Icon = icons[i];
          return <li key={item.title} className="flex gap-5 py-6" data-id="element-158" data-mp="3nabjs06jfi4c" data-mpi={i}>
                <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-sand text-tomato" data-id="element-159" data-mp="1yz3yv3vluejh">
                  <Icon aria-hidden="true" className="h-5 w-5" data-id="element-160" data-mp="1tzragep34zes" />
                </span>
                <div data-id="element-161" data-mp="27v34skzbwnv6">
                  <h3 className="font-sans text-lg font-bold text-ink" data-id="element-162" data-mp="23rdhrzyayec9">{item.title}</h3>
                  <p className="mt-1 font-sans text-base leading-relaxed text-muted" data-id="element-163" data-mp="23trdmb0t3ukv">
                    {item.body}
                  </p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}